import React, { Component } from 'react';
import { FormicaProps, withFormica } from '../../../helpers/withFormica';
import { RootState } from '../../../redux/store';
import { AiModelState } from '../../../redux/reducers/AiModelReducer';
import { changeAiModel, changeAiModelIsUpdate, clearAiModel } from '../../../redux/actions/AiModelActions';
import { enterComponent, leaveComponent } from '../../../redux/actions/ComponentActions';
import { changePageFilter, clearPage } from '../../../redux/actions/PageActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import MlOpsDatasourceComponent from './datasource/MLOpsDatasourceComponent';
import { MLOpsDatasourceSchema } from '../../../domain/mlops/MLOpsSchemaDomains';
import CustomLoading from '../../custom/CustomLoading';

class AiModelDatasourceFeaturesComponent extends Component<Props> {
  public render() {
    const {
      aiModel: { aiModel },
      changeAiModel,
    } = this.props;

    return (
      <div className={'w-full h-full flex flex-col p-[20px] gap-[20px] pt-[30px] scrollable-editor-container overflow-scroll pb-[30px]'}>
        <MlOpsDatasourceComponent
          key='TRAINING'
          type='TRAINING'
          datasource={aiModel.trainingDatasource}
          onChange={(historical: MLOpsDatasourceSchema, file?: File) => {
            aiModel.trainingDatasource = historical;
            changeAiModel(aiModel);
          }}
        />
        <MlOpsDatasourceComponent
          key='VALIDATION'
          type='VALIDATION'
          datasource={aiModel.validationDatasource}
          onChange={(historical: MLOpsDatasourceSchema, file?: File) => {
            aiModel.validationDatasource = historical;
            changeAiModel(aiModel);
          }}
        />
      </div>
    );
  }
}

interface Props extends ReduxProps, FormicaProps {}

const mapStateToProps = (state: RootState) => ({
  aiModel: state.aiModel as AiModelState,
  isUpdate: state.aiModel.isUpdate,
  lastCategory: state.page.lastCategory,
  page: state.page,
});
const mapDispatchToProps = {
  changeAiModelIsUpdate,
  changeAiModel,
  clearAiModel,
  enterComponent,
  leaveComponent,
  clearPage,
  changePageFilter,
};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(AiModelDatasourceFeaturesComponent));
